<template>
  <div class="col col-12 pa-0 input-form v-file-input">
    <span v-if="field.title" class="label">
        <b>{{$t(field.title)}}</b>
        <span v-if="field.props && field.props.required" style="color:red">&nbsp;*</span>
        <infoTooltip v-if="field.tooltip" :tooltip="field.tooltip" />
    </span>
      
    
    <div class="thumbnailInput mb-4" @click="openDialogMediatheque()">
      <span class="activeHover">
        <div v-if="!model[fieldName] || Object.keys(model[fieldName]).length === 0" class="uploadInput">
          <v-icon large>$paperclip_l</v-icon>
        </div>
      </span>
      <div v-if="model[fieldName] && Object.keys(model[fieldName]).length !== 0" class="uploadInput">
        <span class="notmult" v-if="field.props && !field.props.multiple">
          <embed v-if="model[fieldName].mime && model[fieldName].mime === 'application/pdf'" :src="model[fieldName].url + '#zoom=35'" width="300" height="200" />
          <v-img v-else-if="model[fieldName].thumb" :src="model[fieldName].thumb + '?option=x300,y200,crop'" width="300" height="200" ></v-img>
          <v-img :key="model[fieldName]" v-else="model[fieldName]" :src="model[fieldName] + '?option=x300,y200'" max-width="300" max-height="200" ></v-img>
        </span>
        <span class="list" v-else>
          <ul class="mt-2 listItems">
            <li v-for="item in model[fieldName]" :key="item.id" class="mb-2">
              {{item.title && item.title != '' ? item.title : item.filename}}
            </li>
          </ul>
        </span>
      </div>
    </div>

    <div v-if="this.field.specificationsText" class="specifications mt-4">
        <p v-for="(specification, index) in this.field.specificationsText" :key="index" class="mb-0">{{ $t(index) }} : {{ Array.isArray(specification) ? specification.join(", ") : $t(specification) }}</p>
    </div>

    <MediathequeV2DialogComponent v-if="dialogMediatheque" :multiple="multiple" v-model="model[fieldName]" :openDialogMediatheque="dialogMediatheque" @close="closeDialogMediatheque" :prefilters="prefilters" :availableFilters="availableFilters" :upload="true" :returnUrl="returnUrl" :accept="field.props && field.props.accept ? field.props.accept : null" />
  </div>
</template>

<script>
import validate from "../functions/validations";
import MediathequeV2DialogComponent from "../../dialogs/MediathequeV2DialogComponent.vue";
import infoTooltip from '@/components/infoTooltip';

export default {
  components: { MediathequeV2DialogComponent, infoTooltip },
  props: ["model", "fieldName", "field"],
  mixins: [validate],
  data() {
    return {
      dialogMediatheque: false,
      multiple: true,
      returnUrl: false,
      prefilters: {},
      availableFilters: [],
    };
  },
  created() {
    if(typeof this.field.multiple === 'boolean')
        this.multiple = this.field.multiple;
    if(typeof this.field.returnUrl === 'boolean')
        this.returnUrl = this.field.returnUrl;
    this.prefilters = this.field.prefilters ? this.field.prefilters : {};
    this.availableFilters = this.field.availableFilters
      ? this.field.availableFilters
      : [];
  },
  methods: {
    openDialogMediatheque() {
      this.dialogMediatheque = true;
    },
    closeDialogMediatheque: function () {
      this.dialogMediatheque = false;
    },
  },
};
</script>

<style lang="scss">
.thumbnailInput {
  height: 200px !important;
  width: 100%;
  overflow: hidden;
  cursor: pointer;
  border-radius: 4px;
  //border: 1px solid #cccccc;
  position:relative;
  .activeHover {
    width: 100%;
    height: 100%;
    position:absolute;
    .upload {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f0f0f0;
      position:absolute;   
    }
  }
  .uploadInput {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f0f0;
    position:absolute;   
  }
  &:hover {
    .activeHover {
      .upload {
        background: #e0e0e0;
      }
    }
  }
}
.list {
  width: 100%;
}
.listItems {
  list-style: none;
  padding-left:0 !important;
  li {
    padding-left:10px;
    padding-bottom:7px;
    border-bottom:1px solid rgba(0, 0, 0, 0.2);
  }
}
.specifications {
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>